// StatStrip + StatCell - a bordered horizontal stat readout: equal-width
// cells over an optional slim footer row. Graduated from the per-provider
// machines header so every machine surface shares one chrome; the footer
// slot exists for composition rows ("what makes up these numbers") that
// must not add a second box of their own.

import type { ReactNode } from 'react';
import { cn } from '@/lib/classnames';

export function StatStrip({
  children,
  footer,
  className,
}: {
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('border border-ink-800 rounded-lg bg-ink-900/40', className)}>
      <div className="flex divide-x divide-ink-800/60">{children}</div>
      {footer && <div className="border-t border-ink-800/60 px-4 py-2">{footer}</div>}
    </div>
  );
}

export function StatCell({
  label,
  value,
  tint,
}: {
  label: string;
  value: number;
  tint?: 'clean' | 'accent' | 'malicious';
}) {
  const tintClass =
    tint === 'clean'
      ? 'text-verdict-clean'
      : tint === 'accent'
        ? 'text-accent-300'
        : tint === 'malicious'
          ? 'text-verdict-malicious'
          : 'text-ink-200';
  return (
    <div className="flex-1 px-4 py-2.5 min-w-0">
      <div className="text-mini text-ink-500">{label}</div>
      <div className={cn('text-xl font-mono tabular-nums mt-0.5', tintClass)}>{value}</div>
    </div>
  );
}
